export const WYEmailedApplicationsTeamsite = {
  heading: 'EMAILED APPLICATIONS',
  sidebar: {
    header: 'EMAILED APPLICATIONS',
    subText: 'Review information about customer application status.'
  },
  noResultsMessage: 'There are no completed applications to display',
  appSubmitSuccessMessage:
    "The application has been successfully submitted with the payment method of &#34;Send Me a Bill&#34;.<br>Coverage will not begin until payment is received for the full amount of the first month's premium. If payment is not received by the due date, this plan may be cancelled - You can still choose to make a payment now or wait for a bill to arrive.",
  noPaymentSubmitMessage:
    'No payment was submitted with this online application.<br>Information displayed here does not reflect any payment made outside of this online application.<br>Click <strong>More Info</strong> to see more information and options.',
  submitWithPaymentMessage:
    'The application has been successfully submitted and information about payment for the first month’s premium has been received. Please click the link below for a summary<br/><br/>',
  paymentStatusModal: {
    header: 'More Info',
    body:
      'To see if payment has been made and to determine what payment options are available for this plan if payment was not made, contact the Agency Services at  1-866-60 -1248  (TTY/TDD: 711) Monday thru Friday 8:00 a.m. – 5:00 p.m. CST'
  },
  buttons: {
    editInfo: {
      display: true,
      text: 'EDIT INFO'
    },
    viewPlans: {
      display: true,
      text: 'VIEW PLANS'
    },
    planDetails: {
      display: true,
      text: 'PLAN DETAILS'
    },
    compare: {
      display: true,
      text: 'COMPARE'
    },
    edit: {
      display: true,
      text: 'EDIT'
    },
    shopPlans: {
      display: true,
      text: 'CONTINUE'
    },
    goBackToFFM: {
      display: false,
      text: 'GO TO THE MARKETPLACE'
    },
    viewResults: {
      display: true,
      text: 'VIEW RESULTS'
    },
    editOnFFM: {
      display: false,
      text: 'GO TO THE MARKETPLACE'
    },
    initialPayment: {
      display: true,
      text: 'MAKE PAYMENT'
    },
    summary: {
      display: true,
      text: 'SUMMARY'
    },
    moreInfo: {
      display: true,
      text: 'MORE INFO'
    }
  }
};
export const NDEmailedApplicationsTeamsite = {
  heading: 'EMAILED APPLICATIONS',
  sidebar: {
    header: 'EMAILED APPLICATIONS',
    subText: 'Review information about customer application status.'
  },
  noResultsMessage: 'There are no completed applications to display',
  appSubmitSuccessMessage:
    "The application has been successfully submitted with the payment method of &#34;Send Me a Bill&#34;.<br>Coverage will not begin until payment is received for the full amount of the first month's premium. If payment is not received by the due date, this plan may be cancelled - You can still choose to make a payment now or wait for a bill to arrive.",
  noPaymentSubmitMessage:
    'No payment was submitted with this online application.<br>Information displayed here does not reflect any payment made outside of this online application.<br>Click <strong>More Info</strong> to see more information and options.',
  submitWithPaymentMessage:
    'The application has been successfully submitted and information about payment for the first month’s premium has been received. Please click the link below for a summary<br/><br/>',
  paymentStatusModal: {
    header: 'More Info',
    body:
      'To see if payment has been made and to determine what payment options are available for this plan if payment was not made, contact the Agency Services at  1-866-60 -1248  (TTY/TDD: 711) Monday thru Friday 8:00 a.m. – 5:00 p.m. CST'
  },
  buttons: {
    editInfo: {
      display: true,
      text: 'EDIT INFO'
    },
    viewPlans: {
      display: true,
      text: 'VIEW PLANS'
    },
    planDetails: {
      display: true,
      text: 'PLAN DETAILS'
    },
    compare: {
      display: true,
      text: 'COMPARE'
    },
    edit: {
      display: true,
      text: 'EDIT'
    },
    shopPlans: {
      display: true,
      text: 'CONTINUE'
    },
    goBackToFFM: {
      display: false,
      text: 'GO TO THE MARKETPLACE'
    },
    viewResults: {
      display: true,
      text: 'VIEW RESULTS'
    },
    editOnFFM: {
      display: false,
      text: 'GO TO THE MARKETPLACE'
    },
    initialPayment: {
      display: true,
      text: 'MAKE PAYMENT'
    },
    summary: {
      display: true,
      text: 'SUMMARY'
    },
    moreInfo: {
      display: true,
      text: 'MORE INFO'
    }
  }
};
